import { RecurringSettings } from 'src/modules/campaigns/types/RecurringSettings';
import { TextToWinSettings } from 'src/modules/campaigns/types/TextToWinSettings';
import {
  normalizeRecurringSettings,
  normalizeTextToWinSettings,
} from 'src/modules/campaigns/helpers';
import { RecurringTemplateSettings, TextToWinTemplateSettings } from '../types';

/**
 * Map a recurring TEMPLATE settings block (config builder) to runtime
 * RecurringSettings, taking each field's `.default` as the prefilled value.
 * Used by DynamicCampaignBuilder to seed a new campaign from its config.
 */
export const recurringSettingsFromTemplate = (
  template?: RecurringTemplateSettings | null,
): RecurringSettings | null => {
  if (!template) return null;
  return normalizeRecurringSettings({
    period: template.period.default,
    interval: template.interval.default,
    startTime: template.startTime.default,
    endTime: template.endTime.default,
    daysOfWeek: template.daysOfWeek.default,
    dateStart: template.dateStart.default,
    dateEnd: template.dateEnd.default,
  });
};

/**
 * Map a text-to-win TEMPLATE settings block to runtime TextToWinSettings,
 * taking each field's `.default` as the prefilled value.
 */
export const textToWinSettingsFromTemplate = (
  template?: TextToWinTemplateSettings | null,
): TextToWinSettings | null => {
  if (!template) return null;
  return normalizeTextToWinSettings({
    dateStart: template.dateStart.default,
    dateEnd: template.dateEnd.default,
    dateDraw: template.dateDraw.default,
    dateResultsSend: template.dateResultsSend.default,
    entryIntervalMinutes: template.entryIntervalMinutes.default,
    maxEntriesPerInterval: template.maxEntriesPerInterval.default,
    maxEntriesPerContact: template.maxEntriesPerContact.default,
    winnersCount: template.winnersCount.default,
    entrySuccessMessageText: template.entrySuccessMessageText.default,
    winnerMessageText: template.winnerMessageText.default,
    entryIntervalLimitMessageText: template.entryIntervalLimitMessageText.default,
    entryTotalLimitMessageText: template.entryTotalLimitMessageText.default,
    entryNotStartedMessageText: template.entryNotStartedMessageText.default,
    entryEndedMessageText: template.entryEndedMessageText.default,
    nonWinnerMessageText: template.nonWinnerMessageText.default,
  });
};
